module.exports = __webpack_public_path__ + "img/ppt-3.18803cc4.webp";